export const vechicleTypes = {
  small: 'Moto ou bicicleta',
  medium: 'Carro',
  bicycle: 'Bicicleta',
  motorcycle: 'Moto',
  car: 'Carro'
}
